import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Building2,
  BarChart3,
  Settings,
  ChevronLeft,
  ChevronRight,
  Shield,
  Activity,
  CreditCard,
  DollarSign,
  TrendingUp,
  Database,
  Server
} from 'lucide-react';
import { useAdminStore } from '../../stores/adminStore';

const navigation = [
  { name: 'Dashboard', href: '/admin/dashboard', icon: LayoutDashboard },
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Organizations', href: '/admin/organizations', icon: Building2 },
  { name: 'Plans', href: '/admin/plans', icon: CreditCard },
  { name: 'Analytics', href: '/admin/analytics', icon: BarChart3 },
  { name: 'LLM Analytics', href: '/admin/analytics/llm', icon: BarChart3 },
  { name: 'LLM Pricing', href: '/admin/llm-pricing', icon: DollarSign },
  { name: 'Usage Monitoring', href: '/admin/usage-monitoring', icon: Activity },
  { name: 'Redis Monitoring', href: '/admin/redis-monitoring', icon: Server },
  { name: 'Rate Limiting', href: '/admin/rate-limiting', icon: Shield },
  { name: 'Credit Analytics', href: '/admin/credit-analytics', icon: TrendingUp },
  { name: 'Qdrant Inspector', href: '/admin/qdrant', icon: Database },
  { name: 'Settings', href: '/admin/settings', icon: Settings },
];

export default function AdminSidebar() {
  const { sidebarCollapsed, toggleSidebar } = useAdminStore();

  return (
    <div className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ${
      sidebarCollapsed ? 'w-16' : 'w-64'
    } bg-gray-800 border-r border-gray-700`}>
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          {!sidebarCollapsed && (
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 bg-blue-600 rounded-lg">
                <Shield className="w-5 h-5 text-white" />
              </div>
              <span className="text-white font-semibold">Admin Portal</span>
            </div>
          )}
          
          <button
            onClick={toggleSidebar}
            className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
          >
            {sidebarCollapsed ? (
              <ChevronRight className="w-5 h-5" />
            ) : (
              <ChevronLeft className="w-5 h-5" />
            )}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-gray-700'
                }`
              }
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              {!sidebarCollapsed && <span>{item.name}</span>}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-700">
          <div className="text-xs text-gray-500 text-center">
            {!sidebarCollapsed && (
              <>
                <div>CleverAct AI Admin v1.0</div>
                <div className="mt-1">© 2025 CleverAct AI</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
